import { notification } from 'antd';
import { useState } from 'react';

import useAutoCredRequestId from '@/components/App/NewOrder/hooks/useAutoCredRequestId';
import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';
import { handleError } from '@/services/handleError';
import { useAppDispatch, useAppSelector } from '@/store';
import { getResponsesByRequestId } from '@/store/offerStep.slice';
import type { FileType } from '@/types/uploadFiles';

interface IProps {
  onClose: () => void;
}

const useRefund = ({ onClose }: IProps) => {
  const dispatch = useAppDispatch();

  const { selectedBank } = useAppSelector((state) => state.financingStep);

  const { requestId } = useAutoCredRequestId();

  const [isRefundLoading, setIsRefundLoading] = useState(false);

  const handleRefund = async ({ returnLetter }: { returnLetter: FileType }) => {
    if (!selectedBank) return;
    setIsRefundLoading(true);
    try {
      await autoCreditApi.refundRequest(selectedBank.id, returnLetter.base64);
      await dispatch(getResponsesByRequestId({ reqId: requestId }));
      notification.success({
        title: 'Заявление возврата успешно отправлено'
      });
      onClose();
    } catch (error) {
      handleError(error, {
        customTitle: 'Произошла ошибка. Попробуйте позже'
      });
    }
    setIsRefundLoading(false);
  };

  return { isRefundLoading, handleRefund };
};

export default useRefund;
